import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --darkred: #a71924;
    --red: #d0223c;
    --lightbrown: #c09a5d;
    --marineblue: #16345f;
    --oceanblue: #005c8a;
    --lightblue: #368ea2;
    --yellow: #f9b000;
    --darkestgrey: #403d3d;
    --darkgrey: #9d9d9c;
    --grey: #d0d0d0;
    --lightgrey: #ececec;
    --white: #f9f9f9;
    --black: #212121
  }
  html {
    font-size: 7px;
    margin: 0;
    padding: 0;
    height: 100%;
  }
  body {
    font-size: 2rem;
    margin: 0;
    padding: 0;
    height: 100%;
  }
  button {
    position: relative;
    overflow: hidden;
    font-family: Nimbus;
    font-size: 1em;
    letter-spacing: 0.2em;
    color: var(--white);
    text-transform: uppercase !important;
    border: 0;
    box-sizing : content-box;
    padding: 10px;
    cursor: pointer;
    --cast: 2px;
    transition: all 0.2s;
    &:hover {
      --cast: 4px;
    }

    
    width: 100%;

    @media (max-width: 768px) {
      font-size: 0.8em !important;
      letter-spacing: 0.03em;
      padding: 5px;
    }


    &.red {
      background: var(--red);
      &:hover {background-color: var(--darkred);}
    }

    &.white-transparent {
      background: transparent;
      border: 2px solid var(--white);
      &:hover {background-color: var(--lightestgrey);}
    }

    &.black-transparent {
      color: var(--darkestgrey);
      background: transparent;
      border: 2px solid var(--darkestgrey);

      &:hover {background-color: var(--darkgrey);}
    }

    &:active {
      background-color: var(--black);
      transform: translateY(4px);
    }

  }
  .gatsby-image-wrapper img[src*=base64\\,] {
    image-rendering: -moz-crisp-edges;
    image-rendering: pixelated;
  }
  /* Scrollbar Styles */
  body::-webkit-scrollbar {
    width: 12px;
  }
  html {
    scrollbar-width: thin;
    scrollbar-color: var(--red) var(--white);
  }
  body::-webkit-scrollbar-track {
    background: var(--white);
  }
  body::-webkit-scrollbar-thumb {
    background-color: var(--red) ;
    border-radius: 6px;
    border: 3px solid var(--white);
  }
  img {
    max-width: 100%;
  }

.width-container {
  max-width: 1200px;
  display: flex;
  flex-wrap:wrap;
  justify-content: center;
}

`;

export default GlobalStyles;
